import { render, staticRenderFns } from "./GlobalServiceForm.vue?vue&type=template&id=6c6f633d&"
import script from "./GlobalServiceForm.vue?vue&type=script&lang=js&"
export * from "./GlobalServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalServiceForm.vue?vue&type=style&index=0&id=6c6f633d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports